import React, { useRef, useState, useEffect } from "react";
import { ButtonView } from "../../../../controls";
import { VscPreview } from "react-icons/vsc";
import "./PreviewStyles.scss";

const Preview = ({
  imgSrc,
  title,
  subTitle,
  primaryButton,
  secondaryButton,
  device,
  toggleMode = true,
  imageBackgroundColor,
}) => {
  const portraitWidth = device?.portraitWidth; // when screen is in portrait mode
  const width = device?.bannerWidth; // when screen is in landscape mode
  const height = device?.bannerHeight; // when screen is in portrait mode

  const imgWrapperRef = useRef(null); // Create a ref for the div
  const [wrapperWidth, setWrapperWidth] = useState(0); // State to store the width

  useEffect(() => {
    if (imgWrapperRef.current) {
      setWrapperWidth(imgWrapperRef.current.getBoundingClientRect().width);
    }
  }, [imgWrapperRef]);

  const scaleFactor = wrapperWidth / width; // Calculate the scale factor based on the wrapper's width and device width
  const scaledWidth = width * scaleFactor; // Scale the image width
  const scaledHeight = height * scaleFactor; // Scale the image height
  console.log("scaleFactor", scaleFactor);

  const titleStyles = {
    color: title?.color,
    fontSize: title.fontSize
      ? `${title.fontSize * scaleFactor}px`
      : `${14 * scaleFactor}px`,
  };
  const subTitleStyles = {
    color: subTitle?.color,
    fontSize: subTitle?.fontSize
      ? `${subTitle?.fontSize * scaleFactor}px`
      : `${12 * scaleFactor}px`,
  };
  const primaryButtonStyles = {
    backgroundColor: primaryButton?.color,
    fontSize: primaryButton?.fontSize
      ? `${primaryButton?.fontSize * scaleFactor}px`
      : `${12 * scaleFactor}px`,
  };
  const secondaryButtonStyles = {
    backgroundColor: secondaryButton?.color,
    fontSize: secondaryButton?.fontSize
      ? `${secondaryButton?.fontSize * scaleFactor}px`
      : `${12 * scaleFactor}px`,
  };

  return (
    <div className="preview-component-wrapper">
      <div className="preview">
        <div
          className="img-wrapper"
          ref={imgWrapperRef}
          style={{ backgroundColor: imageBackgroundColor }}
        >
          {imgSrc ? (
            <>
              <img
                className={`img-styles ${
                  !imageBackgroundColor && "fill-full-width"
                }`}
                src={imgSrc}
                alt="background-image"
                style={{ height: height, width: scaledWidth }}
              />
              <div className="content-block">
                {title?.visibility?.value === "show" ||
                (title?.title && title?.visibility?.value !== "hidden") ? (
                  <span className="text-content title" style={titleStyles}>
                    {title?.title}
                  </span>
                ) : null}
                {subTitle?.visibility?.value === "show" ||
                (subTitle?.subTitle &&
                  subTitle?.visibility?.value !== "hidden") ? (
                  <span
                    className="text-content subtitle"
                    style={subTitleStyles}
                  >
                    {subTitle?.subTitle}
                  </span>
                ) : null}
                <div className="action-contents">
                  {primaryButton?.visibility?.value === "show" &&
                  primaryButton?.primaryBtnTitle ? (
                    <span className="action-btn">
                      <ButtonView
                        title={primaryButton?.primaryBtnTitle}
                        styles={`btn ${
                          !primaryButton?.color && "transparentBtn"
                        }`}
                        style={primaryButtonStyles}
                      />
                    </span>
                  ) : null}
                  {secondaryButton?.visibility?.value === "show" &&
                  secondaryButton?.secondaryBtnTitle ? (
                    <span className="action-btn">
                      <ButtonView
                        title={secondaryButton?.secondaryBtnTitle}
                        styles={`btn ${
                          !secondaryButton?.color && "transparentBtn"
                        }`}
                        style={secondaryButtonStyles}
                      />
                    </span>
                  ) : null}
                </div>
              </div>
            </>
          ) : (
            <div className="default-content" style={{ height: scaledHeight }}>
              <span>Preview</span>
              <span>
                <VscPreview size={50} />
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Preview;
